module.exports = __webpack_public_path__ + "static/media/XC38-logo.f53c9b4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/XC38/XC38-logo.svg
// module id = 589
// module chunks = 0